export default __webpack_public_path__ + "static/media/LocofastInNews_02.b0d3e31f.webp";